import i18next from 'i18next';
import React, {Component} from 'react';

import Breadcrumb from '~components/Breadcrumb';

import ProjectsChartsComponent from './components/ProjectsChartsComponent';
import CustomList from "~screens/Dashboard/screens/ProjectsIIRSA/components/CustomList";
import {AutocompleteArrayInput, Filter, List, NumberInput, SearchInput, TextField} from "react-admin";
import {RA_LIST_CUSTOM_STYLE} from "~screens/Dashboard/screens/ProjectsIIRSA/constants";
import CustomDatagrid from "~screens/Dashboard/screens/ProjectsIIRSA/components/CustomDatagrid";
import styles from "~screens/Dashboard/screens/ProjectsIIRSA/RoutesList/styles.module.scss";
import {IirsaCountriesService} from "../../../../../../../config/services/iirsa_countries.service";
import OldBreadcrumb from '~components/OldBreadcrumb';

const paths: {
  name: string;
  url?: string;
}[] = [
  { name: 'Ver Proyectos', url: '/projects' }
];

class RouteFilter extends Component {
    state = {
        countries: []
    };

    constructor() {
        super({});
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => this.setState({countries: r.data}));
    }

    render() {
        return (
            <Filter {...this.props}>
                <SearchInput source={'search'} alwaysOn variant={'outlined'}/>

                <AutocompleteArrayInput
                    label="Paises"
                    source="iirsa_countries"
                    choices={this.state.countries}
                    variant={'outlined'}
                />

                <NumberInput label={'Proyectos (mín.)'} source={'cantidad_proyectos_min'} variant={'outlined'}/>
                <NumberInput label={'Proyectos (máx.)'} source={'cantidad_proyectos_max'} variant={'outlined'}/>

                <NumberInput label={'Inversión total (mín.)'} source={'inversion_total_min'} variant={'outlined'}/>
                <NumberInput label={'Inversión total (máx.)'} source={'inversion_total_max'} variant={'outlined'}/>
            </Filter>
        );
    }
}


function IIRSAProjectCharts(props) {
    return (<CustomList
        mapPath={null}
        title={i18next.t('projects-iirsa:analytics')}
        listPath={'/routes'}
        listLabel={i18next.t('projects-iirsa:analytics')}
        chartsPath={'/routes/charts'}
        chartsLabel={i18next.t('projects-iirsa:analytics')}
        breadcrumb={<OldBreadcrumb paths={[
                            {name: i18next.t('projects-iirsa:start')},
                            {name: i18next.t('projects-iirsa:analytics')},
                        ]} title={i18next.t('projects-iirsa:analytics') as string}/>}
        {...props}
    >
        {/*<List*/}
        {/*    {...props}*/}
        {/*    bulkActionButtons={false}*/}
        {/*    // exporter={exporter}*/}
        {/*    filters={<RouteFilter />}*/}
        {/*    // pagination={<PostPagination />}*/}
        {/*    // perPage={50}*/}
        {/*    pagination={false}*/}
        {/*    syncWithLocation={true}*/}
        {/*    sx={RA_LIST_CUSTOM_STYLE}*/}
        {/*>*/}
        {/*    <></>*/}
        {/*</List>*/}
        <div style={{'height': '75px'}}></div>
        <ProjectsChartsComponent showSecondRow={true}/>
    </CustomList>);
}

export default IIRSAProjectCharts;
